import React from 'react'

import Button from "../../../../../../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new"
import {AddView_OptionConfig} from "../../../../../../../../../core/gd-ui/add-view/@types"
import AddView_SelectView from "./select-view"
import AddView_ViewHeader from "./view-header"

type Props = {
    config      : AddView_OptionConfig

    hidePopover : func
    onBack      : func
}

// const debug = "AddViewPreviewRequestForm"
const debug = false

export default function AddViewPreviewRequestForm(props: Props) {

    const onAddRequest = () => {
        props.hidePopover()
        gd.modules.requests.newRequestForm(props.config.formParams.projectId)
    }

    const onAddForm = () => {
        props.hidePopover()
        gd.modules.publicForms.newForm(props.config.formParams.projectId)
    }

    debug && console.log(debug, 'render', props.config)

    const showForm      = props.config.formParams.type === 'form'
    const showRequest   = props.config.formParams.type === 'request'

    return (
        <div className="flex-column-left-top h-100-percent p-l-10 p-r-10">
            <AddView_SelectView onBack={props.onBack}/>

            {showForm &&
                <>
                    <AddView_ViewHeader className="h-100-percent"
                                        viewConfig={{
                                            iconSvg     : 'isvg-forms',
                                            name        : 'Public Form',
                                            description : props.config.description
                                        }}/>

                    <div className="flex-row-center-center w-100-percent m-b-30">
                        <Button className   = "w-125"
                                size        = "36"
                                label       = "New Form"
                                onClick     = {onAddForm}/>
                    </div>
                </>}

            {showRequest &&
                <>
                    <AddView_ViewHeader className="h-100-percent"
                                        viewConfig={{
                                            iconSvg     : 'isvg-request',
                                            name        : 'Request',
                                            description : props.config.description
                                        }}/>

                    <div className="flex-row-center-center w-100-percent m-b-30">
                        <Button className   = "w-125"
                                size        = "36"
                                label       = "New Request"
                                onClick     = {onAddRequest}/>
                    </div>
                </>}
        </div>
    )
}
